import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Left = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.70799 16.2917C9.70799 15.7797 9.90301 15.2677 10.293 14.8777L20.586 4.58463C20.977 4.19363 21.61 4.19363 22 4.58463C22.39 4.97563 22.39 5.60769 22 5.99869L11.707 16.2917L22 26.5846C22.39 26.9756 22.39 27.6077 22 27.9987C21.609 28.3897 20.976 28.3897 20.586 27.9987L10.293 17.7057C9.90201 17.3157 9.70799 16.8037 9.70799 16.2917Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Left
